import {
  BiometricPromptTrackingPoint,
  ReloginBiometricsTrackingPoint,
  ReloginPasswordTrackingPoint,
} from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const BiometricPromptTrackingSchema: Record<
  BiometricPromptTrackingPoint,
  string
> = {
  [BiometricPromptTrackingPoint.PageView]: '',
  [BiometricPromptTrackingPoint.BackClick]: '',
  [BiometricPromptTrackingPoint.EnableBiometricClick]: '',
  [BiometricPromptTrackingPoint.SetupLaterClick]: '',
  [BiometricPromptTrackingPoint.EnableSuccessImpression]: '',
  [BiometricPromptTrackingPoint.EnableSuccessOkClick]: '',
  [BiometricPromptTrackingPoint.EnableFailTooManyTimesOkClick]: '',
  [BiometricPromptTrackingPoint.EnableFailTooManyTimesImpression]: '',
};

const ReloginBiometricsTrackingSchema: Record<
  ReloginBiometricsTrackingPoint,
  string
> = {
  [ReloginBiometricsTrackingPoint.PageView]: '',
  [ReloginBiometricsTrackingPoint.ReloginBiometricLoginClick]: '',
  [ReloginBiometricsTrackingPoint.ReloginSignupClick]: '',
  [ReloginBiometricsTrackingPoint.ReloginWithAnotherAccountClick]: '',
  [ReloginBiometricsTrackingPoint.ReloginWithOtherMethodsClick]: '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsSelectionImpression]: '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithPhoneClick]: '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithPasswordClick]:
    '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithQuickLoginClick]:
    '',
  [ReloginBiometricsTrackingPoint.QuickLoginToggleImpression]: '',
  [ReloginBiometricsTrackingPoint.QuickLoginToggleClick]: '',
  [ReloginBiometricsTrackingPoint.QuickLoginTooltipImpression]: '',
  [ReloginBiometricsTrackingPoint.QuickLoginActionSuccess]: '',
};

const ReloginPasswordTrackingSchema: Record<
  ReloginPasswordTrackingPoint,
  string
> = {
  [ReloginPasswordTrackingPoint.PageView]: '',
  [ReloginPasswordTrackingPoint.ReloginSignupClick]: '',
  [ReloginPasswordTrackingPoint.ReloginWithAnotherAccountClick]: '',
  [ReloginPasswordTrackingPoint.ReloginWithOtherMethodsClick]: '',
  [ReloginPasswordTrackingPoint.ReloginWithPasswordLoginClick]: '',
  [ReloginPasswordTrackingPoint.ForgotPasswordClick]: '',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsSelectionImpression]: '',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithBiometricsClick]:
    '',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithPhoneClick]: '',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithQuickLoginClick]:
    '',
  [ReloginPasswordTrackingPoint.ReloginHelpClick]: '',
  [ReloginPasswordTrackingPoint.QuickLoginToggleImpression]: '',
  [ReloginPasswordTrackingPoint.QuickLoginToggleClick]: '',
  [ReloginPasswordTrackingPoint.QuickLoginTooltipImpression]: '',
  [ReloginPasswordTrackingPoint.QuickLoginActionSuccess]: '',
};
export const getBiometricPromptPageTypeAndSchema = (
  trackingPoint: BiometricPromptTrackingPoint
) => {
  return {
    page_type: PageType.BiometricPromptPage,
    schema: BiometricPromptTrackingSchema[trackingPoint],
  };
};

export const getReloginBiometricsPageTypeAndSchema = (
  trackingPoint: ReloginBiometricsTrackingPoint
) => {
  return {
    page_type: PageType.ReloginBiometricsPage,
    schema: ReloginBiometricsTrackingSchema[trackingPoint],
  };
};

export const getReloginPasswordPageTypeAndSchema = (
  trackingPoint: ReloginPasswordTrackingPoint
) => {
  return {
    page_type: PageType.ReloginPasswordPage,
    schema: ReloginPasswordTrackingSchema[trackingPoint],
  };
};
